"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIdKey = getIdKey;
exports.getId = getId;
exports.getObjectType = getObjectType;
exports.getProperty = getProperty;
exports.getPropertyValue = getPropertyValue;
exports.getPropertyMap = getPropertyMap;
exports.getAssociatedCompanyId = getAssociatedCompanyId;
exports.hasProperty = hasProperty;
exports.isPipelineable = isPipelineable;
exports.setProperty = setProperty;
exports.toString = toString;
exports.toStringExpanded = toStringExpanded;

var _ObjectTypes = _interopRequireDefault(require("customer-data-objects/constants/ObjectTypes"));

var _immutable = require("immutable");

var _I18n = _interopRequireDefault(require("I18n"));

var ObjectRecordAccessors = _interopRequireWildcard(require("customer-data-objects/record/ObjectRecordAccessors"));

var ObjectRecordFormatters = _interopRequireWildcard(require("customer-data-objects/record/ObjectRecordFormatters"));

var _PropertyValueRecord = _interopRequireDefault(require("customer-data-objects/property/PropertyValueRecord"));

function getIdKey(record) {
  return ObjectRecordAccessors.getIdKey(record);
}

function getId(record) {
  return ObjectRecordAccessors.getId(record);
}

function getObjectType(record) {
  return ObjectRecordAccessors.getObjectType(record);
}

function getProperty(record, property) {
  return ObjectRecordAccessors.getProperty(record, property);
}

function getPropertyValue(record, property) {
  return ObjectRecordAccessors.getPropertyValue(record, property);
}
/**
 * Returns an immutable Map of
 *
 *   propertyName => propertyValue
 *
 * Useful when using Records with older code that expects
 * serialized Backbone models.
 */


function getPropertyMap(record) {
  return record.get('properties').map(function (propertyValue) {
    return propertyValue.get('value');
  });
}

function getAssociatedCompanyId(record) {
  var objectType = getObjectType(record);

  if (objectType === _ObjectTypes.default.CONTACT) {
    return getProperty(record, 'associatedcompanyid');
  }

  if (objectType === _ObjectTypes.default.DEAL) {
    return (record.getIn(['associations', 'associatedCompanyIds']) || (0, _immutable.List)()).first();
  }

  return undefined;
}

function hasProperty(record, property) {
  return record.hasIn(['properties', property, 'value']);
}
/**
 * Takes either an `ObjectType` or an `ImmutableModel` and returns whether the
 * associated type is a pipelineable object.
 *
 * @param {ObjectType|Record} subject The subject to test. Can etiher be a CRM
 * ObjectType as defined in `contacts/ObjectTypes` or any object that conforms
 * to the `ImmutableModel`
 * @return {boolean} Whether or not the given subject has associated pipelines
 */


function isPipelineable(subject) {
  var objectType;

  if (typeof subject === 'string') {
    // objectType passed in directly
    objectType = subject;
  } else if (subject instanceof _immutable.Record) {
    objectType = getObjectType(subject);
  }

  if (!objectType) {
    return false;
  }

  return [_ObjectTypes.default.DEAL, _ObjectTypes.default.TICKET].includes(objectType);
}
/**
 * setProperty updates the value of a property on the record.
 * Optionally it can also update the `source` and `sourceId`.
 *
 * @param  {Record}  record   to update
 * @param  {string}  property name of the `property` to change
 * @param  {any}     value
 * @param  {?string} source   (optional)
 * @param  {?string} sourceId (optional)
 *
 * @return {Record}
 */


function setProperty(record, property, value, source, sourceId) {
  var updateValue = function updateValue(propertyValue) {
    var next = propertyValue.set('value', value);

    if (source !== undefined) {
      next = next.set('source', source);
    }

    if (sourceId !== undefined) {
      next = next.set('sourceId', sourceId);
    }

    return next;
  };

  if (record.hasIn(['properties', property])) {
    return record.updateIn(['properties', property], updateValue);
  } // if this property wasn't already set, we need to create
  // a new PropertyValueRecord


  return record.setIn(['properties', property], updateValue((0, _PropertyValueRecord.default)({
    name: property
  })));
}

function toString(record) {
  return ObjectRecordFormatters.toString(_I18n.default.formatName, record);
}

function toStringExpanded(record) {
  return record.constructor.toStringExpanded(record);
}